import { formatContractDateTime } from '../../utils/contractDateUtils';

// The Engine's self-check, one card per cause (owner, 1 Oct 2026: "وليه شكل التحذير غريب كده ؟" - one Salik
// outage showed as three cards, Salik's raw error text and three date styles). The engine tags each check with
// its group (salik / darb / its own id): the checks of a group merge into one card - the worst level and its
// title, each distinct line once, that check's time, and the first fix offered.

const RANK = { error: 2, warn: 1, ok: 0 };

/** A check's time the one way the app writes it: dd/mm/yyyy HH:MM, Dubai (a UTC stamp is converted). */
export const sinceText = (since) => (since ? formatContractDateTime(String(since)) || String(since) : '');

/** Non-ok checks -> [{ id, level, title, lines: [..], since, fixCheck, raw: [..] }], in the engine's order. */
export function groupChecks(checks) {
    const out = [];
    const byGroup = {};
    (checks || []).filter((c) => c && c.level !== 'ok').forEach((c) => {
        const key = c.group || c.id;
        let g = byGroup[key];
        if (!g) {
            g = { id: c.id, level: c.level, title: c.title, lines: [], since: c.since || null, fixCheck: null, raw: [] };
            byGroup[key] = g;
            out.push(g);
        } else if ((RANK[c.level] || 0) > (RANK[g.level] || 0)) {
            Object.assign(g, { id: c.id, level: c.level, title: c.title, since: c.since || g.since });
        }
        if (c.detail && !g.lines.includes(c.detail)) g.lines.push(c.detail);
        if (c.raw && !g.raw.includes(c.raw)) g.raw.push(c.raw);
        if (!g.fixCheck && c.fix) g.fixCheck = c;
    });
    return out;
}
